import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

function FlowSelector() {
  const [activeButton, setActiveButton] = useState("Appraiser");

  return (
    <div className="d-flex justify-content-end mb-3">
      <Button
        className={`btn ${
          activeButton === "Repairer" ? "gradient" : "neutral"
        }`}
        onClick={() => setActiveButton("Repairer")}
      >
        Repairer
      </Button>
      <Button
        className={`mx-2 btn ${
          activeButton === "Leaser" ? "gradient" : "neutral"
        }`}
        onClick={() => setActiveButton("Leaser")}
      >
        Leaser
      </Button>
      <Button
        className={`btn ${activeButton === "Dealer" ? "gradient " : "neutral"}`}
        onClick={() => setActiveButton("Dealer")}
      >
        Dealer
      </Button>
      <Button
        className={`mx-2 btn ${
          activeButton === "Appraiser" ? "gradient" : "neutral"
        }`}
        onClick={() => setActiveButton("Appraiser")}
      >
        Appraiser
      </Button>
    </div>
  );
}

export default FlowSelector;
